exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h5[data-v-5dffa8a8]{font-weight:700}.sidebar-link[data-v-5dffa8a8]{cursor:pointer;text-decoration:underline;transition:all .1s ease}.sidebar-link[data-v-5dffa8a8]:hover{color:#0056b3!important;text-decoration:none;font-weight:700}.marginality-calculation-table .table th[data-v-5dffa8a8]{background-color:#f8f9fa;border-top:none;font-weight:600;color:#495057}", ""]);

// exports
